import axios from "./axiosInstance";

export const requestPhoneAuth = async (phone_number) => {
  try {
    const res = await axios.post("/api/auth/send-verification", {
      phone_number,
    });

    if (res.data.success === true) {
      alert(res.data.message);
    }

    return res.data;
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const verifyPhoneCode = async (phone_number, verification_code) => {
  try {
    const res = await axios.post("/api/auth/verify-code", {
      phone_number,
      verification_code,
    });

    return res.data;
  } catch (err) {
    console.error(err);

    return {};
  }
};
